"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
function useErrorModal(defaultValue) {
    return (0, vue_1.reactive)({
        open: defaultValue,
        message: "",
    });
}
exports.default = useErrorModal;
